// Stores
import { useUiStore } from '@stores/ui'

// Personal lib
import { UpdateServiceNameEnum } from './common/update-service-enum'
import { UpdateService } from './common/update-service.class'
import { logger } from '../../lib/logger/logger-manager'
import programRepository from 'src/data/repository/program.repository'
import { RepositoryStrategyEnum } from '@shared/enum/repository-strategy.enum'

export class UpdateManagerProgram {
  /**
   * UpdateService : get all programs
   */
  static ProgramAll = class UpdateServiceProgramAll extends UpdateService {
    updateServiceName = UpdateServiceNameEnum.PROGRAM_ALL

    /**
     * Cron store of cron task
     */
    private uiStore = useUiStore()

    task(forcedStrategy?: RepositoryStrategyEnum) {
      return programRepository.getPrograms(forcedStrategy)
        .then(localRslt => {
          this.uiStore.programs = localRslt

          return localRslt
        })
        .catch(err => logger?.info('getPrograms - err : ', err.message))
    }
  }
}
